import { Component, ViewChild } from '@angular/core';
import { Platform, ToastController, IonicApp, App, Nav/* , AlertController */ } from 'ionic-angular';
import iphoneXchecker from './iphoneX-checker';
import { TabsPage } from '../pages/tabs/tabs';

@Component({
	templateUrl: 'app.html'
})
export class MyApp {

	rootPage:any = 'TabsPage';
	@ViewChild(Nav) nav: Nav;

	constructor(private platform: Platform, private toastCtrl: ToastController, private ionicApp: IonicApp, private app: App/* , private alertCtrl: AlertController */) {
		this.platform.ready().then(() => {
			// Okay, so the platform is ready and our plugins are available.
			// Here you can do any higher level native things you might need.
			iphoneXchecker();
			this.check4updates();
			this.setupBackButtonBehavior();
		});
	}

	async check4updates() {
		// Listen to the service worker promise in index.html
		// to see if there has been a new update.
		// Condition: the service-worker.js needs to have some kind of change.
		console.log('check4updates()');
		const installingWorker = await window['initAggiornamentoDisp']();
		console.log('check4updates > installingWorker = ', installingWorker);
		if (installingWorker) {
			const toast = this.toastCtrl.create({
				message: "Abbiamo aggiornato l'app. Clicca su OK per caricare l'ultima versione.",
				position: 'bottom',
				showCloseButton: true,
				closeButtonText: 'OK',
			});
			toast.onDidDismiss(() => {
				installingWorker.postMessage({ action: 'skipWaiting' });
			});
			toast.present();
		}
	}

	// reloadApp() {
	// 	window.location.reload();
	// }

	// closeApp() {
	// 	this.platform.exitApp();
	// 	navigator['app'].exitApp();
	// }

	private setupBackButtonBehavior () {

		// If on web version (browser)
		if (window.location.protocol !== "file:") {

			// Register browser back button action(s)
			window.onpopstate = (evt) => {
				if(window['avoidPopState'] == 1) {
					window['avoidPopState'] = 0;
					return;
				}

				// Close menu if open
				// if (this._menu.isOpen()) {
				// 	this._menu.close ();
				// 	return;
				// }

				// Close any active modals or overlays
				const activePortal = /* this.ionicApp._loadingPortal.getActive() || */
					this.ionicApp._modalPortal.getActive() ||
					this.ionicApp._toastPortal.getActive() ||
					this.ionicApp._overlayPortal.getActive();

				if (activePortal) {
					activePortal.dismiss();
					return;
				}

				const view = this.nav.getActive(); // As none of the above have occurred, its either a page pushed from a tab
				const page = view.instance;

				if (!(page instanceof TabsPage)) { // Check if the current page is pushed from a menu click
					if (this.nav.canGoBack() || (view && view.isOverlay)) {
						this.nav.pop(); //pop if page can go back or if its an overlay over a menu page
					} else {
						// this.showAlert();
					}
					return;
				}

				const tabs = this.app.getActiveNav(); // So it must be a view from a tab.

				if (!tabs.canGoBack()) {
					return; // this.showExitAlert( tabs );
				}

				return tabs.pop();

				// Navigate back
				// const rootNav = this.app.getRootNav();
				// console.log('maybe can go back');
				// if (rootNav.canGoBack()) {
				// 	console.log('can go back');
				// 	rootNav.pop();
				// }

			};

			// Fake browser history on each view enter
			this.app.viewDidEnter.subscribe((app) => {
				history.pushState(null, null, "");
			});

		}

	}

	// private showExitAlert( tabs ) {
	// 	const alert = this.alertCtrl.create({
	// 		title: "Uscire dall'app?",
	// 		message: "Vuoi uscire dall'app?",
	// 		buttons: [
	// 			{
	// 				text: 'Annulla',
	// 				role: 'cancel',
	// 				handler: () => {}
	// 			},
	// 			{
	// 				text: 'Esci',
	// 				handler: () => window.history.back() //tabs.pop()
	// 			}
	// 		]
	// 	});
	// 	alert.present();
	// }

	// private showExitInfo() {
	// 	let alert = this.alertCtrl.create({
	// 		title: 'Te ne vai già?',
	// 		subTitle: 'Se vuoi uscire dall\'app premi il tasto Home del telefono',
	// 		buttons: ['Dismiss']
	// 	});
	// 	alert.present();
	// }

}



// WEBPACK FOOTER //
// ./src/app/app.component.ts